function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { ConsoleApiName } from '../../tools/display';
import { NO_ERROR_STACK_PRESENT_MESSAGE, isError } from '../error/error';
import { toStackTraceString } from '../../tools/stackTrace/handlingStack';
import { getExperimentalFeatures } from '../../tools/experimentalFeatures';
import { INTAKE_SITE_STAGING, INTAKE_SITE_US1_FED } from '../intakeSites';
import { Observable } from '../../tools/observable';
import { clocksNow } from '../../tools/utils/timeUtils';
import { displayIfDebugEnabled, startMonitorErrorCollection } from '../../tools/monitor';
import { sendToExtension } from '../../tools/sendToExtension';
import { performDraw } from '../../tools/utils/numberUtils';
import { jsonStringify } from '../../tools/serialisation/jsonStringify';
import { combine } from '../../tools/mergeInto';
import { computeStackTrace } from '../../tools/stackTrace/computeStackTrace';
import { getConnectivity } from '../connectivity';
import { createBoundedBuffer } from '../../tools/boundedBuffer';
import { canUseEventBridge, getEventBridge, startBatchWithReplica } from '../../transport';
import { DISCARDED } from '../../tools/abstractHooks';
import { TelemetryType } from './rawTelemetryEvent.types';
var ALLOWED_FRAME_URLS = ['https://www.datadoghq-browser-agent.com', 'https://www.datad0g-browser-agent.com', 'https://d3uc069fcn7uxw.cloudfront.net', 'https://d20xtzwzcl0ceb.cloudfront.net', 'http://localhost', '<anonymous>'];
var TELEMETRY_EXCLUDED_SITES = [INTAKE_SITE_US1_FED]; // eslint-disable-next-line local-rules/disallow-side-effects

var preStartTelemetryBuffer = createBoundedBuffer();

var _onRawTelemetryEventCollected2 = function onRawTelemetryEventCollected(event, kind) {
  preStartTelemetryBuffer.add(function () {
    return _onRawTelemetryEventCollected2(event, kind);
  });
};

export function startTelemetry(telemetryService, configuration, hooks, reportError, pageMayExitObservable, createEncoder) {
  var observable = new Observable();

  var _startTelemetryTransp = startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, observable),
      stop = _startTelemetryTransp.stop;

  var _startTelemetryCollec = startTelemetryCollection(telemetryService, configuration, hooks, observable),
      enabled = _startTelemetryCollec.enabled;

  return {
    stop: stop,
    enabled: enabled
  };
}
export function startTelemetryCollection(telemetryService, configuration, hooks, observable) {
  var _telemetryEnabledPerT;

  var alreadySentEventsByKind = {};
  var telemetryEnabled = !TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && performDraw(configuration.telemetrySampleRate);
  var telemetryEnabledPerType = (_telemetryEnabledPerT = {}, _defineProperty(_telemetryEnabledPerT, TelemetryType.LOG, telemetryEnabled), _defineProperty(_telemetryEnabledPerT, TelemetryType.CONFIGURATION, telemetryEnabled && performDraw(configuration.telemetryConfigurationSampleRate)), _defineProperty(_telemetryEnabledPerT, TelemetryType.USAGE, telemetryEnabled && performDraw(configuration.telemetryUsageSampleRate)), _telemetryEnabledPerT);
  var runtimeEnvInfo = getRuntimeEnvInfo();

  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(rawEvent, kind) {
    if (!telemetryEnabledPerType[rawEvent.type]) {
      return;
    }

    var alreadySentEvents = alreadySentEventsByKind[kind];

    if (!alreadySentEvents) {
      alreadySentEvents = alreadySentEventsByKind[kind] = new Set();
    }

    if (alreadySentEvents.size >= configuration.maxTelemetryEventsPerPage) {
      return;
    }

    var stringifiedEvent = jsonStringify(rawEvent);

    if (alreadySentEvents.has(stringifiedEvent)) {
      return;
    }

    var defaultTelemetryEventAttributes = hooks.triggerHook(1
    /* HookNames.AssembleTelemetry */
    , {
      startTime: clocksNow().relative
    });

    if (defaultTelemetryEventAttributes === DISCARDED) {
      return;
    }

    var event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
    observable.notify(event);
    sendToExtension('telemetry', event);
    alreadySentEvents.add(stringifiedEvent);
  }; // need to be called after telemetry context is provided and observers are registered


  preStartTelemetryBuffer.drain();
  startMonitorErrorCollection(addTelemetryError);
  return {
    enabled: telemetryEnabled
  };

  function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
    var clockNow = clocksNow();
    var event = {
      type: 'telemetry',
      date: clockNow.timeStamp,
      service: telemetryService,
      version: "6.16.0",
      source: 'browser',
      _dd: {
        format_version: 2
      },
      telemetry: combine(rawEvent, {
        runtime_env: runtimeEnvInfo,
        connectivity: getConnectivity(),
        sdk_setup: "npm"
      }),
      experimental_features: Array.from(getExperimentalFeatures())
    };
    return combine(event, defaultTelemetryEventAttributes);
  }
}

function startTelemetryTransport(configuration, reportError, pageMayExitObservable, createEncoder, telemetryObservable) {
  var cleanupTasks = [];

  if (canUseEventBridge()) {
    var bridge = getEventBridge();
    var telemetrySubscription = telemetryObservable.subscribe(function (event) {
      return bridge.send('internal_telemetry', event);
    });
    cleanupTasks.push(function () {
      return telemetrySubscription.unsubscribe();
    });
  } else {
    var telemetryBatch = startBatchWithReplica(configuration, {
      endpoint: configuration.rumEndpointBuilder,
      encoder: createEncoder(4
      /* DeflateEncoderStreamId.TELEMETRY */
      )
    }, configuration.replica && {
      endpoint: configuration.replica.rumEndpointBuilder,
      encoder: createEncoder(5
      /* DeflateEncoderStreamId.TELEMETRY_REPLICA */
      )
    }, reportError, pageMayExitObservable, // We don't use an actual session expire observable here, to make telemetry collection
    // independent of the session. This allows to start and send telemetry events ealier.
    new Observable());
    cleanupTasks.push(function () {
      return telemetryBatch.stop();
    });

    var _telemetrySubscription = telemetryObservable.subscribe(function (event) {
      telemetryBatch.add(event, isTelemetryReplicationAllowed(configuration));
    });

    cleanupTasks.push(function () {
      return _telemetrySubscription.unsubscribe();
    });
  }

  return {
    stop: function stop() {
      return cleanupTasks.forEach(function (task) {
        return task();
      });
    }
  };
}

function getRuntimeEnvInfo() {
  return {
    is_local_file: window.location.protocol === 'file:',
    is_worker: 'WorkerGlobalScope' in self
  };
}

export function startFakeTelemetry() {
  var events = [];

  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(event) {
    events.push(event);
  };

  return events;
}
export function resetTelemetry() {
  preStartTelemetryBuffer = createBoundedBuffer();

  _onRawTelemetryEventCollected2 = function _onRawTelemetryEventCollected(event, kind) {
    preStartTelemetryBuffer.add(function () {
      return _onRawTelemetryEventCollected2(event, kind);
    });
  };
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */

export function isTelemetryReplicationAllowed(configuration) {
  return configuration.site === INTAKE_SITE_STAGING;
}
export function addTelemetryDebug(message, context) {
  displayIfDebugEnabled(ConsoleApiName.debug, message, context);

  _onRawTelemetryEventCollected2(_objectSpread({
    type: TelemetryType.LOG,
    message: message,
    status: "debug"
    /* StatusType.debug */

  }, context), "debug"
  /* StatusType.debug */
  );
}
export function addTelemetryError(e, context) {
  _onRawTelemetryEventCollected2(_objectSpread(_objectSpread({
    type: TelemetryType.LOG,
    status: "error"
    /* StatusType.error */

  }, formatError(e)), context), "error"
  /* StatusType.error */
  );
}
export function addTelemetryConfiguration(configuration) {
  _onRawTelemetryEventCollected2({
    type: TelemetryType.CONFIGURATION,
    configuration: configuration
  }, TelemetryType.CONFIGURATION);
}
export function addTelemetryMetrics(kind, context) {
  _onRawTelemetryEventCollected2(_objectSpread({
    type: TelemetryType.LOG,
    message: kind,
    status: "debug"
    /* StatusType.debug */

  }, context), kind);
}
export function addTelemetryUsage(usage) {
  _onRawTelemetryEventCollected2({
    type: TelemetryType.USAGE,
    usage: usage
  }, TelemetryType.USAGE);
}
export function formatError(e) {
  if (isError(e)) {
    var stackTrace = computeStackTrace(e);
    return {
      error: {
        kind: stackTrace.name,
        stack: toStackTraceString(scrubCustomerFrames(stackTrace))
      },
      message: stackTrace.message
    };
  }

  return {
    error: {
      stack: NO_ERROR_STACK_PRESENT_MESSAGE
    },
    message: "Uncaught"
    /* NonErrorPrefix.UNCAUGHT */
    .concat(" ", jsonStringify(e))
  };
}
export function scrubCustomerFrames(stackTrace) {
  stackTrace.stack = stackTrace.stack.filter(function (frame) {
    return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) {
      return frame.url.startsWith(allowedFrameUrl);
    });
  });
  return stackTrace;
}